<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import LoginStepWrapper from '../LoginStepWrapper.vue';
import TheTermsAndConditionsModal from '@components/ui/prepay&terms-and-conditions/TheTermsAndConditionsModal.vue';

const { tokenDisabled } = defineProps<{
    message?: string;
    rejectionText?: string;
    tokenDisabled?: boolean;
}>();

const emit = defineEmits<{
    close: [];
    submit: [];
    switch: [];
}>();

const authStore = useAuthStore();
const analyticsStore = useAnalyticsStore();
const { loading } = classToRefs(authStore);
const mobile = defineModel<string>('username', { default: '' });
const error = computed(() => authStore.error.MobileOrEmail || '');
const { open } = useModal({
    component: TheTermsAndConditionsModal,
    attrs: { mobilePage: true },
    modalAttrs: {
        zIndexFn: () => 2147483648,
    },
});
const { isWebApp } = useDevice();
</script>

<template>
    <div class="logo-container">
        <img src="/img/simple-logo.png" class="logo" alt="logo" />
        <mr-typography size="x-large" weight="500" color="var(--blue-400)">
            مِستربلیط
        </mr-typography>
    </div>
    <!-- <mr-typography v-if="message" color="var(--gray-800)">
        {{ message }}
    </mr-typography> -->
    <LoginStepWrapper
        title="ورود | ثبت‌نام"
        sub-title="برای ادامه، شماره موبایل خود را وارد کنید."
        webapp-placement="between"
        @submit="emit('submit')"
    >
        <template #inputs="{ focus }">
            <div class="input-content">
                <mr-input
                    v-model="mobile"
                    input-id="phonenumber"
                    type="number"
                    placeholder="شماره موبایل"
                    dir="ltr"
                    :error-text="error"
                    :hide-description="!error"
                    :invalid="!!error"
                    required
                    autofocus
                    @focus="focus"
                    @submit="emit('submit')"
                />
                <div class="terms-conditions">
                    <mr-icon :icon="faCircleInfo" color="var(--gray-700)" />
                    <mr-typography
                        size="small"
                        weight="500"
                        color="var(--gray-700)"
                    >
                        استفاده از مِستربلیط به معنای پذیرش
                        <mr-typography
                            v-if="isWebApp"
                            type="span"
                            size="small"
                            color="var(--blue-400)"
                            weight="700"
                            @click="open()"
                        >
                            شرایط و مقررات
                        </mr-typography>
                        <NuxtLink
                            v-else
                            to="/support/terms-and-conditions"
                            target="_blank"
                        >
                            <mr-typography
                                type="span"
                                size="small"
                                color="var(--blue-400)"
                                weight="700"
                            >
                                شرایط و مقررات
                            </mr-typography>
                        </NuxtLink>
                        آن است.
                    </mr-typography>
                </div>
            </div>
        </template>
        <template #actions>
            <!-- <mr-button
                v-if="rejectionText"
                id="rejection-btn"
                variant="transparent"
                full-width
                @click="emit('close')"
            >
                {{ rejectionText }}
            </mr-button> -->
            <mr-button
                id="login-btn-step1"
                type="submit"
                :disabled="tokenDisabled || !mobile"
                :loading
                full-width
                @click="analyticsStore.trackAll('login_otp_request_click')"
            >
                ادامه و دریافت کد
            </mr-button>
            <mr-typography align="center" color="var(--gray-700)" weight="500">
                برای ورود با ایمیل یا رمز ثابت
                <mr-typography
                    type="span"
                    color="var(--blue-400)"
                    weight="500"
                    class="pass-login"
                    @click="emit('switch')"
                >
                    اینجا کلیک کنید!
                </mr-typography>
            </mr-typography>
        </template>
    </LoginStepWrapper>
</template>

<style lang="scss" scoped>
.logo-container {
    @include desktop-only {
        display: none;
        visibility: hidden;
    }
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    align-items: center;
    .logo {
        width: 48px;
        height: 48px;
    }
}
.input-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .terms-conditions {
        display: flex;
        gap: 6px;
        align-items: start;
    }
}

.pass-login {
    cursor: pointer;
}
</style>
